import { getDictionaryOverride } from '../providers/embedConfig'
import { deepMerge } from '../util/deepMerge'
import { bundledDictionaries } from './dictionaries'
import type { Dict, SupportedLocale } from './types'

/**
 * Resolve the dictionary for a locale. Bundled today — but this is the ONE place to swap for an
 * endpoint fetch later (e.g. `GET {BASE}/tradein/i18n/{locale}.json`) without touching the
 * provider, hook, or any UI. Kept async so the provider already handles a network source; falls
 * back to the bundled copy so the UI never blocks on i18n.
 *
 * A brand can deep-override any string via `tradeInConfig.dictionary[locale]` (the escape hatch for
 * wording the {noun} lexicon can't express) — those overrides are merged over the bundled copy here.
 */
export async function loadDictionary(locale: SupportedLocale): Promise<Dict> {
  const base = bundledDictionaries[locale]
  const override = getDictionaryOverride(locale)
  return override ? deepMerge(base, override) : base
}
